import { createContext, Dispatch, SetStateAction } from "react";
import { Timezone } from "../components-v2/common/layout/Layout";
import { IGlobalDateFilter } from "../models/filters/IFilters";

export interface GloBalDateFilter extends ICurrentTime {
  globalFilterDate: IGlobalDateFilter;
  setGlobalFilterDate: Dispatch<SetStateAction<IGlobalDateFilter>>;
  globalStaticFilterDate: IGlobalDateFilter;
  setGlobalStaticFilterDate: Dispatch<SetStateAction<IGlobalDateFilter>>;
  setSelectedFilter: Dispatch<SetStateAction<string>>;
}

export interface FlightSelectionID {
  flightID: string | undefined;
  flightDocID: string | undefined;
}

export interface FlightSelection {
  selectedFlight: FlightSelectionID;
  setSelectedFlight: Dispatch<SetStateAction<FlightSelectionID>>;
}

export interface FlightFilterParams {
  legType: string | null;
  flightIDs: string[];
}

export interface FlightFilter {
  flightFilterParams: FlightFilterParams;
  setFlightFilterParams: Dispatch<SetStateAction<FlightFilterParams>>;
}
export interface TimeZone {
  timezone: Timezone;
  setTimezone: Dispatch<SetStateAction<Timezone>>;
}

export interface LayoutContextType
  extends GloBalDateFilter, FlightSelection, FlightFilter, TimeZone {
  isMapView: boolean;
  setIsMapView: Dispatch<SetStateAction<boolean>>;
  isMappedInView: boolean;
  setIsMappedInView: Dispatch<SetStateAction<boolean>>;
  selectedFilter: string;
}

export interface ICurrentTime {
  currentTime: Date;
  setCurrentTime: Dispatch<SetStateAction<Date>>;
}

export const LayoutContext = createContext<LayoutContextType>({
  isMapView: false,
  setIsMapView: () => {},
  isMappedInView: false,
  setIsMappedInView: () => {},
  selectedFlight: { flightID: undefined, flightDocID: undefined },
  flightFilterParams: { legType: "", flightIDs: [] },
  globalFilterDate: { startDate: new Date(), endDate: new Date() },
  globalStaticFilterDate: { startDate: new Date(), endDate: new Date() },
  timezone: "LT",
  currentTime: new Date(),
  selectedFilter: "",
  setSelectedFlight: () => {},
  setGlobalFilterDate: () => {},
  setGlobalStaticFilterDate: () => {},
  setFlightFilterParams: () => {},
  setTimezone: () => {},
  setSelectedFilter: () => {},
  setCurrentTime: () => {},
});
